export default __webpack_public_path__ + "static/media/b4chainlogo.364d63db.png";